import { tsUtils } from '@neo-one/ts-utils';
import { Types } from '../../constants';
import { IsHelper } from './IsHelper';
import { UnwrapCopyStructHelper } from './UnwrapCopyStructHelper';
import { WrapHelper } from './WrapHelper';
export class UnwrapArrayStorageHelper extends UnwrapCopyStructHelper {
}
export class WrapArrayStorageHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.ArrayStorage;
    }
}
export class IsArrayStorageHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.ArrayStorage;
    }
}
export const hasArrayStorage = (context, node, type) => tsUtils.type_.hasType(type, (tpe) => isArrayStorage(context, node, tpe));
export const isOnlyArrayStorage = (context, node, type) => tsUtils.type_.isOnlyType(type, (tpe) => isArrayStorage(context, node, tpe));
export const isArrayStorage = (context, node, type) => context.builtins.isInterface(node, type, 'ArrayStorage');

//# sourceMappingURL=arrayStorage.js.map
